import { post } from '../api-service'

export interface EmailCaptureParams {
  email: string
  event_name?: string
  page_source?: string
  campaign?: string
  location?: string
  content_type?: string
  slug?: string
  type?: string
  platform?: string
  category?: string
  cookie_consent?: boolean
  page_type?: string
  class_type?: string
  coming_soon_slug?: string
  marketing_consent?: boolean
  product?: string
  event_id?: string
}

export const trackEmailCapture = async (payload: EmailCaptureParams) =>
  post('/api/v3/growth/email-capture', payload)
